// Store.
import { AppState } from 'store';

// Types.
import { DashboardState } from './types';

export const dashboardSelector = ({ dashboardState }: AppState): DashboardState => dashboardState;
